<template>
  <div class="information-island">
    <template v-if="!hasSent">
      <validation-observer
        ref="observer"
        tag="form"
        class="information-island__form-container inputs-container"
        @submit.prevent="validateForm()">
        <validation-provider
          rules="required"
          slim
          mode="passive">
          <template slot-scope="{ errors }">
            <oie-base-input
              id="leadName"
              v-model="fullName"
              :label-text="`${t('fullName')}*`"
              :placeholder="t('fullNamePlaceholder')"
              :error-messages="errors"></oie-base-input>
          </template>
        </validation-provider>

        <validation-provider
          rules="required|email"
          slim
          mode="passive">
          <template slot-scope="{ errors }">
            <oie-base-input
              id="leadEmail"
              v-model="email"
              :label-text="`${t('email')}*`"
              :placeholder="t('emailPlaceholder')"
              :error-messages="errors"></oie-base-input>
          </template>
        </validation-provider>

        <validation-provider
          rules="required"
          mode="passive"
          slim>
          <template slot-scope="{ errors }">
            <oie-base-input
              id="errand"
              v-model="errand"
              :textarea="true"
              :label-text="`${t('errand')}*`"
              :placeholder="t('errandPlaceholder')"
              :error-messages="errors"></oie-base-input>
          </template>
        </validation-provider>

        <oie-base-button
          v-element-loader="{ endpoint: 'lead/addticket' }"
          type="submit"
          css-classes="button--with-border button--green"
          :text="t('sendButton')"></oie-base-button>
      </validation-observer>
    </template>
    <template v-else>
      <h2 class="info-contact__sent-title">
        {{ t('errandSentTitle') }}
      </h2>
      <div class="info-contact__sent-text" v-html="t('errandSentText')"></div>
      <oie-base-button
        type="button"
        css-classes="button--with-border button--green"
        :text="t('sendNewErrand')"
        @click="hasSent = false"></oie-base-button>
    </template>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    fullName: null,
    email: null,
    errand: null,
    hasSent: false
  }),
  methods: {
    async validateForm() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        // ABORT
      } else {
        this.send()
      }
    },
    async send() {
      try {
        await httpService.post('lead/addticket', { fullname: this.fullName, email: this.email, errandtext: this.errand })
        this.fullName = ''
        this.email = ''
        this.errand = ''
        this.hasSent = true
      } catch(e) {
        // do nothing
      }
    }
  }
}
</script>

<style lang="scss">
.info-contact__sent-title {
  @include h3-semi-bold;
}

.info-contact__sent-text {
  margin-bottom: 2rem;
}
</style>
